import { BUCKET_MEANING_FA } from './inspect-detail';

/** راهنمای bucket «ایندکس‌نشده» (excluded) — منبع واحد برای UI */

export const EXCLUDED_BUCKET_GUIDE_TITLE = 'ایندکس‌نشده (excluded)';

export const EXCLUDED_BUCKET_GUIDE_INTRO = [
  BUCKET_MEANING_FA,
  'وقتی درخواست وضعیت ایندکس موفق است ولی صفحه ایندکس‌شده حساب نمی‌شود، در bucket ایندکس‌نشده (excluded) قرار می‌گیرد.',
];

export const EXCLUDED_COVERAGE_STATE_ROWS = [
  {
    coverageState: 'Submitted and indexed',
    uiGuide: 'دارد',
    bucket: 'indexed',
    note: 'این مورد ایندکس‌شده است، نه excluded.',
  },
  {
    coverageState: 'Duplicate without user-selected canonical',
    uiGuide: 'ندارد (ولی ذخیره می‌شود)',
    bucket: 'excluded',
  },
  {
    coverageState: 'Discovered - currently not indexed',
    uiGuide: 'دارد',
    bucket: 'excluded',
  },
  {
    coverageState: 'Crawled - currently not indexed',
    uiGuide: 'دارد',
    bucket: 'excluded',
  },
  {
    coverageState: "Excluded by 'noindex' tag",
    uiGuide: 'دارد',
    bucket: 'excluded',
  },
  {
    coverageState: 'Page with redirect',
    uiGuide: 'دارد',
    bucket: 'excluded',
  },
] as const;

export function excludedBucketGuideParagraphs(): string[] {
  const lines = [
    ...EXCLUDED_BUCKET_GUIDE_INTRO,
    'نمونه‌های رایج coverageState و bucket:',
    ...EXCLUDED_COVERAGE_STATE_ROWS.filter((row) => row.bucket === 'excluded').map(
      (row) =>
        `• ${row.coverageState} — راهنمای UI: ${row.uiGuide} → bucket: ${row.bucket}`,
    ),
    'سایر coverageStateهای گوگل هم اگر شرط ایندکس‌شده نباشند، excluded می‌شوند.',
  ];
  return lines;
}
